import { Box, Button, Flex, Text } from '@chakra-ui/react';
import type { CardProps } from '@ui/components/Card';
import { Card } from '@ui/components/Card';
import { TokenIcon } from '@ui/components/TokenIcon';
import { useUseYourTokenDrawer } from '@ui/components/useYourTokenDrawer';
import { useTranslations } from '@ui/i18n';
import type { FC } from 'react';
import React from 'react';

import { useVnoProtocols } from './utils';

export const UseVnoCard: FC<CardProps> = (props) => {
  const t = useTranslations();
  const vnoProtocols = useVnoProtocols();

  return (
    <Card
      display="flex"
      minH="86px"
      p={{
        base: '10px',
        desktop: '10px 16px 18px',
      }}
      gap="10px"
      mx="0"
      justifyContent="space-between"
      cursor="pointer"
      bgImage={{
        base: "url('/images/pattern-3.png')",
        desktop: "url('/images/use-vno-bg.png')",
      }}
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPos={{
        base: 'center -152px',
        desktop: 'center center',
      }}
      bgBlendMode={{
        desktop: 'color-burn',
      }}
      onClick={() => {
        useUseYourTokenDrawer.getState().onOpen({
          title: t('Use your {coin}', {
            coin: 'VNO',
          }),
          protocols: vnoProtocols,
        });
      }}
      {...props}
    >
      <Box>
        <Flex alignItems="center" gap="4px">
          <TokenIcon token="vno" w="32px" h="32px" />
          <Text
            textStyle={{
              base: 'bodySmall',
              desktop: 'h4Bold',
            }}
          >
            {t('Use your {coin}', {
              coin: 'VNO',
            })}
          </Text>
        </Flex>
        <Text
          textStyle={{
            base: 'bodySmall',
            desktop: 'body',
          }}
          color="text-light"
          mt={{
            base: '4px',
            desktop: '14px',
          }}
        >
          {t('Explore the Veno ecosystem to put your VNO to work')}
        </Text>
      </Box>
      <Button variant="secondary" size="sm">
        {t('View')}
      </Button>
    </Card>
  );
};
